import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
import { environment } from "../../env";

export const DocumentationApp = () => (
  <SwaggerUI url={environment.documentationUrl} />
);
export default DocumentationApp;
